import "core-js";
import "whatwg-fetch";

import * as moment from "moment";

import ready from "./ready";
import GeckoCalendar from "./Components/GeckoCalendar";

ready(() => {
	GeckoCalendar.searchAndLoad();
});